import Serializer from 'umg-ember-backend/serializers/application';

export default class ExternalReferenceSerializer extends Serializer {
  attrs = {
    artist: 'themeId',
    division: 'divisionId',
    position: 'cmsPosition',
    type: 'categoryId',
  };
}
